import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    projId = '',
    level = '0', // > 0 查询指标审核层级的日志
    action = '', // 不为空查询指标操作类型
    search = '',
    pi = 1,
    ps = 50,
}, options = { showError: true }) => {
    if (!projId) {
        return Promise.resolve({
            rows: [],
            total: 0,
            pc: 0,
            pi,
            ps,
        });
    }
    const [ content, error, status ] = await POST(URLS.kpi.projKpiAudit.getAuditLogPage, {
        projId,
        level: Number.parseInt(level) || 0,
        action,
        search,
        pi,
        ps,
    }, options);
    if (error) return { error, status };
    return content || { };
};
